import { render, staticRenderFns } from "./FollowRequestAction.vue?vue&type=template&id=1592bbf1&"
import script from "./FollowRequestAction.vue?vue&type=script&lang=js&"
export * from "./FollowRequestAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports